<template>
  <div class="alternative-payments__container">
    <div
      v-if="alternativePayments.klarna_text &&
        alternativePayments.klarna_icon"
      class="alternative-payments__provider"
    >
      <img
        class="alternative-payments__icon"
        :src="alternativePayments.klarna_icon"
        :alt="alternativePayments.klarna_icon.alt"
      >

      <p
        class="text-body-2xs alternative-payments__info"
        v-html="updatePaymentPrices(alternativePayments.klarna_text)"
      />
    </div>

    <div
      v-if="alternativePayments.clear_pay_text &&
        alternativePayments.clear_pay_icon"
      class="alternative-payments__provider"
    >
      <img
        class="alternative-payments__icon"
        :src="alternativePayments.clear_pay_icon"
        :alt="alternativePayments.clear_pay_icon.alt"
      >

      <div
        class="text-body-2xs alternative-payments__info"
        v-html="updatePaymentPrices(alternativePayments.clear_pay_text)"
      />
    </div>

    <div
      v-if="alternativePayments.pay_pal_text &&
        alternativePayments.pay_pal_icon"
      class="alternative-payments__provider"
    >
      <img
        class="alternative-payments__icon"
        :src="alternativePayments.pay_pal_icon"
        :alt="alternativePayments.pay_pal_icon.alt"
      >

      <div
        class="text-body-2xs alternative-payments__info"
        v-html="updatePaymentPrices(alternativePayments.pay_pal_text)"
      />
    </div>

    <div
      v-if="alternativePayments.revolut_text &&
        alternativePayments.revolut_icon"
      class="alternative-payments__provider"
    >
      <img
        class="alternative-payments__icon"
        :src="alternativePayments.revolut_icon"
        :alt="alternativePayments.revolut_icon.alt"
      >

      <div
        class="text-body-2xs alternative-payments__info"
        v-html="updatePaymentPrices(alternativePayments.revolut_text)"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Alternative payments (alternative-payments)
 * -----------------------------------------------------------------------------
 * Alternative Payments Provider and the breakdown to the payments required for each provider.
 *
 * @param {Object} alternativePayments - Payment objects with a text and icons.
 * @param {Number} price - Product price, in cents format.
 */

export default {
  name: 'AlternativePayments',

  props: {
    alternativePayments: {
      type: Object,
      default: () => {},
    },
    price: {
      type: [Number, Boolean],
      default: 0,
    },
  },

  methods: {

    /**
     * Replace keyword with correct divided price for different payment provider.
     * @param {String} text - Payment text.
     * @return {String}
     */
    updatePaymentPrices(text) {
      let amount

      switch (true) {
        case text.includes('{divide3}'):
          amount = this.price / 3
          text = text.replace('{divide3}', '')
          break
        case text.includes('{divide4}'):
          amount = this.price / 4
          text = text.replace('{divide4}', '')
          break
        default:
          return text
      }

      return text.replace('{amount}', this.$formatMoney(amount))
    },
  },
}
</script>

<style lang="scss">
@import './alternative-payments';
</style>
